<fieldset>
    <legend>
        TypeObjCPV
    </legend>

    <button class="btn btn-outline-primary" (click)="addtypeCPVClass()">Ajouter un typeCPVClass</button>
    <div *ngFor="let obj of cpv.objetComplementaire; let i = index">
      <fieldset>
        <legend>
          typeCPVClass {{ i + 1}}
        </legend>
        <button class="btn btn-outline-primary" (click)="removetypeCPVClass(i)">Supprimer un typeCPVClass</button>
        <app-typeCPV-class [uid]="getUid()+'_index_'+(i+1)" [parentForm]="parentForm" [objetPrincipal]="obj"></app-typeCPV-class>
      </fieldset>
    </div>

    <fieldset>
        <legend>
            objetPrincipal
        </legend>
        <app-typeCPV-class [uid]="getUid()" [parentForm]="parentForm" [objetPrincipal]="cpv.objetPrincipal">
        </app-typeCPV-class>
    </fieldset>
</fieldset>
